<script>

    import layer from "@/mixins/mapboxLayer";
   
   import {featureCollection} from '@turf/helpers'
   
   import circle from '@turf/circle'

   import lineDistance from '@turf/length'
   
    // import {lineDistance,circle,featureCollection} from '@turf/turf'

    export default{
        
        mixins:[layer],
        
        name:"elevationfeatured",

        data(){
            return {
                sourceOptions:{buffer:0,tolerance:1},
            }
        },
        

        computed:{
            geoJSON:function(){
                return false;
            },
            visible:function(){
                return this.$store.state.altimetriaVisible
            },
        },

        created:function(){

                  window.UIEvents.$on("elevationHover",({distance,elevation})=>{
                    //   if(!this.visible) return false
                        //get the lat and lng of the current km
                        var point = this.$store.getters.pointFromDistance(distance);
                        var geoGsonFinal = featureCollection(this.generate3dFeature([point]))
                        console.log(geoGsonFinal)
                        this._geoJSON = geoGsonFinal
                        this.setSource();
                  })

                  window.UIEvents.$on("elevationOut",()=>{
                        this._geoJSON = false;
                        this.setSource();
                 })

        },

        watch:{

        },

        methods:{
            generate3dFeature:function(points3d){
                return _.map(points3d, point3d =>{
                    var zoom = this.map.getZoom();
                    var radius = _.fromToInterpolation(12,15,150,45,zoom,true)
                    console.log(zoom)
                    console.log(radius)
                    var feature3d = circle(point3d, radius, {units: 'meters',steps:6});
                    var z = _.get(point3d, 'geometry.coordinates');
                    z = _.fromToInterpolation(999,1110,1,500,z[2])
                    feature3d.properties['z_value'] =  z+2;
                    return feature3d;
                })
            }
        },

        style: function () {
            return {
                'type': 'fill-extrusion',
                "light": {
                    "anchor": "viewport",
                    "color": "white",
                    "intensity": 1
                },
                'paint': {
                    // See the Mapbox Style Specification for details on data expressions.
                    // https://www.mapbox.com/mapbox-gl-js/style-spec/#expressions
        
                    // Get the fill-extrusion-color from the source 'color' property.
                    'fill-extrusion-color': 'white',
        
                    // Get fill-extrusion-height from the source 'height' property.
                    'fill-extrusion-height': ['get', 'z_value'],
        
                    // Get fill-extrusion-base from the source 'base_height' property.
                    'fill-extrusion-base': 0,
        
                    // Make extrusions slightly opaque for see through indoor walls.
                    'fill-extrusion-opacity': 1,
                    'fill-extrusion-ambient-occlusion-intensity': 0.4,
                    'fill-extrusion-cast-shadows':false,




                }
            }
        }

    }


</script>